// Company legal identity - RESERVACION CANCUN LLC (trade name: RSV TRANSFERS)
export const COMPANY = {
  legalName: "RESERVACION CANCUN LLC",
  tradeName: "RSV TRANSFERS",
  addressLines: ["30 N Gould St Ste N", "Sheridan, WY 82801", "Estados Unidos"],
  addressInline: "30 N Gould St Ste N, Sheridan, WY 82801, USA",
  email: "contact@rsvcancun.com",
  phone: "+52 998 790 7699",
  website: "rsvcancun.com",
};

// Terms & Conditions content (provided by the client - verbatim).
export const TERMS = {
  updated: "Última actualización: 31 de agosto de 2026",
  intro: [
    "Bienvenido a RSV TRANSFERS, nombre comercial de RESERVACION CANCUN LLC.",
    "Los presentes Términos y Condiciones regulan el acceso y uso del sitio web de RSV TRANSFERS, así como la solicitud, reservación, contratación y prestación de los servicios de transportación ofrecidos a través de nuestros canales de venta.",
    "Al realizar una reservación, efectuar un pago o utilizar cualquiera de nuestros servicios, el cliente declara haber leído, comprendido y aceptado los presentes Términos y Condiciones.",
  ],
  sections: [
    {
      title: "IDENTIFICACIÓN DEL PRESTADOR DEL SERVICIO",
      content: [
        { type: "ul", items: [
          "Razón social: RESERVACION CANCUN LLC",
          "Nombre comercial: RSV TRANSFERS",
          "Domicilio: 30 N Gould St Ste N, Sheridan, WY 82801, Estados Unidos",
          "Correo electrónico: contact@rsvcancun.com",
          "Teléfono de contacto: +52 998 790 7699",
          "Sitio web: rsvcancun.com",
        ]},
        { type: "p", text: "RESERVACION CANCUN LLC opera comercialmente bajo la marca RSV TRANSFERS, especializada en servicios de transportación privada y turística de pasajeros, principalmente en Cancún, Riviera Maya y otros destinos disponibles dentro de nuestra cobertura." },
      ],
    },
    {
      title: "OBJETO Y DESCRIPCIÓN DE LOS SERVICIOS",
      content: [
        { type: "p", text: "RSV TRANSFERS ofrece servicios de transportación de pasajeros, incluyendo, entre otros:" },
        { type: "ul", items: [
          "Traslados privados desde y hacia aeropuertos.",
          "Transportación entre hoteles, resorts y alojamientos.",
          "Traslados a destinos turísticos.",
          "Transportación privada dentro de las zonas disponibles de servicio.",
          "Servicios de transportación previamente reservados.",
          "Traslados de llegada y salida.",
          "Servicios especiales de transportación que hayan sido previamente cotizados y confirmados.",
        ]},
        { type: "p", text: "Las características específicas de cada servicio, incluyendo origen, destino, fecha, horario, número de pasajeros, tipo de vehículo y cualquier servicio adicional, serán las establecidas en la confirmación de reservación correspondiente." },
      ],
    },
    {
      title: "USO DEL SITIO WEB",
      content: [
        { type: "p", text: "El usuario se compromete a utilizar nuestro sitio web únicamente para fines legales y relacionados con la consulta o contratación de nuestros servicios." },
        { type: "p", text: "Queda prohibido:" },
        { type: "ul", items: [
          "Utilizar información falsa o de terceros sin autorización.",
          "Realizar reservaciones fraudulentas.",
          "Intentar acceder sin autorización a sistemas, bases de datos o áreas restringidas.",
          "Interferir con el funcionamiento del sitio web.",
          "Copiar, reproducir o explotar comercialmente los contenidos del sitio sin autorización.",
          "Utilizar el sitio para actividades ilegales, fraudulentas o que puedan ocasionar daños a RSV TRANSFERS o a terceros.",
        ]},
        { type: "p", text: "RSV TRANSFERS podrá restringir o cancelar el acceso de usuarios que incumplan estas condiciones." },
      ],
    },
    {
      title: "RESERVACIONES",
      content: [
        { type: "p", text: "El cliente es responsable de proporcionar información completa y correcta al momento de realizar su reservación." },
        { type: "p", text: "Dependiendo del servicio contratado, podremos solicitar:" },
        { type: "ul", items: [
          "Nombre completo del pasajero principal.",
          "Número de pasajeros.",
          "Fecha y horario del servicio.",
          "Aeropuerto, hotel o lugar de origen.",
          "Destino.",
          "Número de vuelo, cuando corresponda.",
          "Información de contacto.",
          "Cantidad y características especiales del equipaje.",
          "Información adicional necesaria para prestar correctamente el servicio.",
        ]},
        { type: "p", text: "Una reservación se considerará confirmada cuando el cliente haya recibido una confirmación por parte de RSV TRANSFERS y, cuando corresponda, se haya realizado satisfactoriamente el pago requerido." },
        { type: "p", text: "El cliente deberá revisar cuidadosamente la información contenida en su confirmación." },
        { type: "p", text: "Cualquier error deberá ser comunicado a RSV TRANSFERS tan pronto como sea posible." },
      ],
    },
    {
      title: "PRECIOS",
      content: [
        { type: "p", text: "Los precios mostrados en nuestro sitio web, cotizaciones, enlaces de pago o confirmaciones corresponden al servicio y condiciones específicamente indicadas." },
        { type: "p", text: "Los precios pueden variar dependiendo de factores como:" },
        { type: "ul", items: [
          "Origen y destino.",
          "Tipo de vehículo.",
          "Número de pasajeros.",
          "Horarios o fechas especiales.",
          "Servicios adicionales.",
          "Cambios solicitados por el cliente.",
          "Distancias o recorridos adicionales.",
          "Condiciones particulares del servicio.",
        ]},
        { type: "p", text: "Una vez confirmada y pagada una reservación, el precio correspondiente al servicio contratado será respetado, salvo que el cliente solicite modificaciones que generen costos adicionales." },
      ],
    },
    {
      title: "PAGOS",
      content: [
        { type: "p", text: "RSV TRANSFERS podrá aceptar diferentes medios de pago disponibles al momento de la reservación, incluyendo pagos electrónicos y tarjetas de crédito o débito mediante proveedores de procesamiento de pagos autorizados." },
        { type: "p", text: "El cliente declara que está autorizado para utilizar el método de pago seleccionado." },
        { type: "p", text: "Cuando una transacción utilice mecanismos de autenticación, incluyendo tecnologías como 3D Secure, la autenticación realizada por el titular podrá considerarse evidencia de autorización de la operación, sin perjuicio de los derechos que correspondan al consumidor conforme a la legislación aplicable." },
        { type: "p", text: "RSV TRANSFERS podrá rechazar, suspender o solicitar información adicional respecto de una operación cuando existan motivos razonables para verificar su legitimidad o prevenir fraude." },
      ],
    },
    {
      title: "CONFIRMACIÓN DEL SERVICIO",
      content: [
        { type: "p", text: "Después de completar correctamente una reservación, el cliente podrá recibir una confirmación mediante correo electrónico, mensaje electrónico, WhatsApp u otro canal utilizado durante la contratación." },
        { type: "p", text: "El cliente deberá conservar dicha confirmación y presentarla cuando sea solicitada." },
        { type: "p", text: "La confirmación deberá indicar los elementos principales del servicio contratado." },
      ],
    },
    {
      title: "VUELOS Y RETRASOS",
      content: [
        { type: "p", text: "Para servicios relacionados con llegadas aéreas, es responsabilidad del cliente proporcionar correctamente su número de vuelo y demás información solicitada." },
        { type: "p", text: "Cuando RSV TRANSFERS disponga de dicha información, podremos utilizarla para coordinar el servicio tomando en consideración posibles cambios en el horario de llegada." },
        { type: "p", text: "Sin embargo, retrasos significativos, cancelaciones, cambios de aeropuerto, cambios de vuelo o modificaciones que alteren sustancialmente el servicio originalmente contratado podrán requerir una nueva coordinación y estarán sujetos a disponibilidad." },
        { type: "p", text: "El pasajero deberá comunicar cualquier cambio relevante tan pronto tenga conocimiento del mismo." },
      ],
    },
    {
      title: "TIEMPOS DE ESPERA",
      content: [
        { type: "p", text: "Los tiempos de espera aplicables podrán variar dependiendo del tipo de servicio contratado." },
        { type: "p", text: "El cliente deberá presentarse en el punto de encuentro indicado dentro del horario establecido." },
        { type: "p", text: "Cuando el pasajero no se presente y no exista comunicación que permita localizarlo o coordinar el servicio, la reservación podrá ser considerada como No-Show." },
        { type: "p", text: "Los tiempos extraordinarios de espera podrán generar cargos adicionales cuando impliquen una extensión significativa del servicio originalmente contratado." },
      ],
    },
    {
      title: "NO-SHOW",
      content: [
        { type: "p", text: "Se considerará No-Show cuando el pasajero no se presente en el lugar y horario establecidos y no exista comunicación suficiente para coordinar razonablemente el servicio." },
        { type: "p", text: "En caso de No-Show, RSV TRANSFERS podrá considerar el servicio como prestado para efectos de la reservación y los importes pagados podrán no ser reembolsables, sujeto a las circunstancias particulares y a la legislación de protección al consumidor aplicable." },
      ],
    },
    {
      title: "CAMBIOS EN LA RESERVACIÓN",
      content: [
        { type: "p", text: "Las solicitudes de modificación de fecha, horario, origen, destino, número de pasajeros o características del servicio estarán sujetas a disponibilidad." },
        { type: "p", text: "RSV TRANSFERS procurará atender las solicitudes de modificación recibidas con anticipación razonable." },
        { type: "p", text: "Cuando una modificación implique un incremento en distancia, tiempo, capacidad, tipo de vehículo u otros costos operativos, el cliente deberá cubrir la diferencia correspondiente antes de la prestación del servicio." },
      ],
    },
    {
      title: "CANCELACIONES Y REEMBOLSOS",
      content: [
        { type: "p", text: "Las condiciones específicas de cancelación y reembolso aplicables a cada reservación podrán depender del tipo de servicio, tarifa contratada y anticipación con la que se solicite la cancelación." },
        { type: "p", text: "Cuando exista una política específica de cancelación mostrada durante el proceso de compra o incluida en la confirmación, dicha política formará parte de las condiciones de la reservación." },
        { type: "p", text: "RSV TRANSFERS informará al cliente de cualquier importe no reembolsable aplicable antes o durante el proceso de contratación, de conformidad con la legislación aplicable." },
        { type: "p", text: "Cuando un servicio sea cancelado directamente por RSV TRANSFERS y no pueda proporcionarse una alternativa razonable, se ofrecerá al cliente la solución correspondiente conforme a las circunstancias y a la legislación aplicable." },
      ],
    },
    {
      title: "EQUIPAJE",
      content: [
        { type: "p", text: "El pasajero es responsable de informar cuando transporte equipaje que exceda las condiciones normales del servicio, incluyendo equipaje de gran tamaño, equipos deportivos, carriolas, sillas de ruedas u objetos especiales." },
        { type: "p", text: "La capacidad de equipaje dependerá del vehículo asignado y del número de pasajeros." },
        { type: "p", text: "RSV TRANSFERS podrá solicitar la contratación de un vehículo de mayor capacidad cuando el equipaje declarado exceda la capacidad segura de la unidad originalmente seleccionada." },
        { type: "p", text: "Los pasajeros son responsables de verificar sus pertenencias antes de abandonar el vehículo." },
      ],
    },
    {
      title: "MENORES DE EDAD",
      content: [
        { type: "p", text: "Los menores de edad deberán viajar acompañados por un adulto responsable, salvo que RSV TRANSFERS haya autorizado expresamente otra modalidad de servicio." },
        { type: "p", text: "Cuando el cliente requiera dispositivos o condiciones especiales para transportar menores, deberá solicitarlo previamente para confirmar disponibilidad." },
      ],
    },
    {
      title: "CONDUCTA DEL PASAJERO",
      content: [
        { type: "p", text: "Los pasajeros deberán mantener una conducta respetuosa y segura durante el servicio." },
        { type: "p", text: "RSV TRANSFERS podrá negarse a iniciar o continuar un servicio cuando la conducta de un pasajero represente un riesgo para:" },
        { type: "ul", items: [
          "El conductor.",
          "Otros pasajeros.",
          "Terceros.",
          "El vehículo.",
          "La seguridad de la operación.",
        ]},
        { type: "p", text: "No se permite realizar actividades ilegales dentro de los vehículos." },
        { type: "p", text: "Los daños ocasionados intencionalmente o por negligencia del pasajero podrán ser responsabilidad de quien los haya provocado." },
      ],
    },
    {
      title: "VEHÍCULOS Y OPERACIÓN DEL SERVICIO",
      content: [
        { type: "p", text: "El vehículo utilizado para prestar el servicio podrá variar dependiendo de disponibilidad, capacidad y necesidades operativas, manteniendo características adecuadas para el servicio contratado." },
        { type: "p", text: "Cuando resulte necesario para la operación, RSV TRANSFERS podrá coordinar la prestación del servicio mediante conductores, operadores o proveedores debidamente habilitados conforme corresponda." },
        { type: "p", text: "La contratación a través de RSV TRANSFERS no implica necesariamente que RESERVACION CANCUN LLC sea propietaria de todas las unidades utilizadas para prestar los servicios." },
      ],
    },
    {
      title: "CAUSAS DE FUERZA MAYOR",
      content: [
        { type: "p", text: "RSV TRANSFERS no será responsable por retrasos o imposibilidad de prestar un servicio cuando sean consecuencia de circunstancias fuera de nuestro control razonable, incluyendo, entre otras:" },
        { type: "ul", items: [
          "Accidentes o cierres de carreteras.",
          "Tráfico extraordinario.",
          "Fenómenos meteorológicos severos.",
          "Huracanes.",
          "Inundaciones.",
          "Desastres naturales.",
          "Manifestaciones o bloqueos.",
          "Actos de autoridad.",
          "Emergencias.",
          "Fallas generales de infraestructura.",
          "Situaciones de fuerza mayor o caso fortuito.",
        ]},
        { type: "p", text: "En dichas circunstancias se realizarán esfuerzos razonables para ofrecer alternativas cuando sea posible." },
      ],
    },
    {
      title: "LIMITACIÓN DE RESPONSABILIDAD",
      content: [
        { type: "p", text: "RSV TRANSFERS realizará esfuerzos razonables para prestar los servicios confirmados de manera segura, puntual y profesional." },
        { type: "p", text: "Sin embargo, en la máxima medida permitida por la legislación aplicable, no será responsable por daños indirectos, incidentales o consecuenciales derivados de circunstancias fuera de su control razonable." },
        { type: "p", text: "Nada de lo establecido en estos Términos y Condiciones pretende excluir o limitar responsabilidades que legalmente no puedan excluirse, incluyendo los derechos obligatorios que correspondan al consumidor." },
      ],
    },
    {
      title: "INFORMACIÓN PROPORCIONADA POR EL CLIENTE",
      content: [
        { type: "p", text: "El cliente garantiza que la información proporcionada durante el proceso de reservación es verdadera, actualizada y suficiente para prestar el servicio." },
        { type: "p", text: "RSV TRANSFERS no será responsable por problemas directamente ocasionados por información incorrecta proporcionada por el cliente, incluyendo errores en fechas, vuelos, hoteles, destinos, horarios, teléfonos o número de pasajeros." },
      ],
    },
    {
      title: "PROPIEDAD INTELECTUAL",
      content: [
        { type: "p", text: "Todos los contenidos disponibles en el sitio web de RSV TRANSFERS, incluyendo, cuando corresponda:" },
        { type: "ul", items: [
          "Logotipos.",
          "Nombre comercial.",
          "Diseños.",
          "Fotografías propias.",
          "Textos.",
          "Material gráfico.",
          "Elementos visuales.",
          "Software.",
          "Estructura y diseño del sitio.",
        ]},
        { type: "p", text: "son propiedad de RESERVACION CANCUN LLC, de sus respectivos titulares o son utilizados bajo autorización." },
        { type: "p", text: "Queda prohibida su reproducción, modificación, distribución, comercialización o utilización sin autorización previa cuando dicha autorización sea legalmente necesaria." },
      ],
    },
    {
      title: "PROTECCIÓN DE DATOS PERSONALES",
      content: [
        { type: "p", text: "La información personal proporcionada por los usuarios será utilizada principalmente para gestionar reservaciones, prestar los servicios contratados, comunicarnos con los pasajeros, procesar operaciones y cumplir las obligaciones legales y administrativas correspondientes." },
        { type: "p", text: "El tratamiento de datos personales se realizará de conformidad con nuestro Aviso de Privacidad y la legislación aplicable." },
      ],
    },
    {
      title: "SERVICIOS Y ENLACES DE TERCEROS",
      content: [
        { type: "p", text: "El sitio web puede utilizar o contener servicios proporcionados por terceros, incluyendo plataformas de pago, mapas, sistemas de comunicación u otros proveedores tecnológicos." },
        { type: "p", text: "RSV TRANSFERS no controla necesariamente las políticas, disponibilidad o funcionamiento de plataformas externas." },
        { type: "p", text: "Cuando el usuario utilice un servicio externo también podrán resultar aplicables los términos y políticas del proveedor correspondiente." },
      ],
    },
    {
      title: "MODIFICACIONES A LOS TÉRMINOS Y CONDICIONES",
      content: [
        { type: "p", text: "RESERVACION CANCUN LLC podrá actualizar los presentes Términos y Condiciones cuando resulte necesario por cambios operativos, comerciales, tecnológicos o legales." },
        { type: "p", text: "Las modificaciones serán publicadas en el sitio web indicando la fecha de actualización correspondiente." },
        { type: "p", text: "Las condiciones aplicables a una reservación serán, en principio, las vigentes al momento de su contratación, salvo modificaciones exigidas por disposición legal." },
      ],
    },
    {
      title: "LEGISLACIÓN Y JURISDICCIÓN",
      content: [
        { type: "p", text: "RESERVACION CANCUN LLC es una sociedad de responsabilidad limitada con domicilio comercial en Sheridan, Wyoming, Estados Unidos." },
        { type: "p", text: "Sin perjuicio de las normas imperativas de protección al consumidor y demás disposiciones que puedan resultar aplicables por el lugar donde se contrata o presta el servicio, las relaciones corporativas y comerciales de RESERVACION CANCUN LLC se regirán conforme a la legislación que corresponda a su constitución y operación." },
        { type: "p", text: "Debido a que los servicios de transportación pueden prestarse físicamente en México, determinadas obligaciones relacionadas con la operación del transporte, protección al consumidor, seguridad, turismo y demás materias podrán estar sujetas a las leyes y autoridades mexicanas competentes." },
        { type: "p", text: "Ninguna disposición de estos Términos y Condiciones deberá interpretarse como una renuncia del consumidor a derechos que legalmente sean irrenunciables." },
      ],
    },
    {
      title: "ACEPTACIÓN",
      content: [
        { type: "p", text: "Al utilizar nuestro sitio web, realizar una reservación, completar un pago o utilizar nuestros servicios, el cliente reconoce que ha tenido acceso a estos Términos y Condiciones y acepta las disposiciones que resulten aplicables a su contratación." },
        { type: "p", text: "La aceptación electrónica de estos términos tendrá los efectos permitidos por la legislación aplicable." },
      ],
    },
    {
      title: "CONTACTO",
      content: [
        { type: "p", text: "Para cualquier pregunta, aclaración o solicitud relacionada con una reservación o con estos Términos y Condiciones, puede comunicarse con:" },
        { type: "ul", items: [
          "RESERVACION CANCUN LLC",
          "Nombre comercial: RSV TRANSFERS",
          "30 N Gould St Ste N",
          "Sheridan, WY 82801",
          "Estados Unidos",
          "Correo electrónico: contact@rsvcancun.com",
          "Teléfono: +52 998 790 7699",
          "Sitio web: rsvcancun.com",
        ]},
      ],
    },
  ],
  copyright: "© 2026 RESERVACION CANCUN LLC – RSV TRANSFERS. Todos los derechos reservados.",
};
